export default function ({ req, app }) {
  if (process.server && req) {
    const host = req.headers.host || ''
    const protocol = req.headers['x-forwarded-proto'] || 'https'
    const fullUrl = `${protocol}://${host}${req.url}`

    app.head = app.head || {}
    app.head.link = app.head.link || []

    // 去除 query/hash
    const cleanUrl = fullUrl.split('?')[0].split('#')[0]

    // 去除重复 canonical
    app.head.link = app.head.link.filter((l) => l.rel !== 'canonical')

    app.head.link.push({
      rel: 'canonical',
      href: cleanUrl,
    })
  }
}
